import React from "react";

function AboutUs() {
  return (
    <section className="page-section bg-primary mb-5 text-white" id="about">
      <div className="pb-5 container mb-5 pt-0">
        {/* <!-- About Section Heading--> */}
        <div className="text-center pt-0">
          <h2 className="page-section-heading d-inline-block text-white">
            ABOUT ME
          </h2>
        </div>
        {/* <!-- Icon Divider--> */}
        <div className="divider-custom divider-light pb-4">
          <div className="divider-custom-line"></div>
          <div className="divider-custom-icon">
            <i className="fas fa-star"></i>
          </div>
          <div className="divider-custom-line"></div>
        </div>
        {/* <!-- About Section Content--> */}
        <div className="row" style={{ fontSize: "1.7rem" }}>
          <div className="col-lg-4 ml-auto">
            <div className="lead">
              Hello,
              <br />
              Myself Dishant Aarak, and I'm currently pursuing my degree in
              BSc.IT from BAMU University.
            </div>
          </div>
          <br />
          <div className="col-lg-4 mr-auto">
            <div className="lead">
              You can ask me about Advanced JavaScript, C++, Python, Java and
              Android Development. I love chatting with residents around the
              area and learning more about what they’re looking for from their
              smart devices.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
